import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { Loading, TransactionDetailHeader } from '@reveni-io/reveni-ui'

import useReviewAdditionalProducts from './hooks/useReviewAdditionalProducts/useReviewAdditionalProducts'
import ProductsCard from './ProductsCard/ProductsCard'
import SummaryCard from './SummaryCard/SummaryCard'
import * as Styles from './styles'

const TransactionReviewAdditionalProductsPage = () => {
  const { id } = useParams()
  const { t } = useTranslation()

  const {
    unexpectedItems,
    gettingUnexpectedItems,
    linkToOrder,
    discard,
    confirming,
    confirmDisabled,
    handleCancel,
    handleConfirm,
    detailUrl,
  } = useReviewAdditionalProducts({ returnId: id })

  return (
    <Styles.Container>
      <Loading show={gettingUnexpectedItems || confirming}>
        <TransactionDetailHeader
          showArrowsNavigation={false}
          orderNumber={t('Revisar productos devueltos adicionales')}
          defaultBackUrl={detailUrl}
          backListButtonText={t('Volver')}
        />
        <Styles.MainContainer>
          <ProductsCard items={unexpectedItems} onLink={linkToOrder} onDiscard={discard} />
          <SummaryCard
            items={unexpectedItems}
            onCancel={handleCancel}
            onConfirm={handleConfirm}
            confirmDisabled={confirmDisabled}
          />
        </Styles.MainContainer>
      </Loading>
    </Styles.Container>
  )
}

export default TransactionReviewAdditionalProductsPage
